<div class="row">
  <div class="col-12 col-lg-4 offset-lg-4">
    <h1>Page Not Found</h1>
    <p>The Url you entered is not valid.</p>
    <p>Go to the <a routerLink="/sample-search">DNA Sample Search</a> page</p>
  </div>
</div>
